import { z } from "zod";
/**
 * A MakeHuman character (`avatar.mh` in the user settings, see `AvatarSpecSchema`): a sex, up to
 * `MH_LIMITS.morphs` slider values in -1..1 and the items it wears, all ids of the bundled kit the
 * web app owns (`apps/web/public/world/models/mh/manifest.json`). The gateway checks only the shape
 * and the ranges; ids it does not know are kept, and the client falls back to a default for any id
 * its kit no longer has, so a saved character survives the kit growing or shrinking.
 */
export const MH_LIMITS = {
    morphs: 64,
    accessories: 3,
    skin: 32,
    eyes: 16,
};
const ItemId = z.string().regex(/^[a-z0-9][a-z0-9-]{0,47}$/);
const SliderId = z.string().regex(/^[a-zA-Z][a-zA-Z0-9]{0,31}$/);
const Hex = z.string().regex(/^#[0-9a-fA-F]{6}$/);
export const MhAvatarSchema = z
    .object({
    v: z.literal(1),
    sex: z.enum(["male", "female"]),
    morphs: z
        .record(SliderId, z.number().min(-1).max(1))
        .refine((m) => Object.keys(m).length <= MH_LIMITS.morphs, { message: "too many morphs" }),
    skin: z
        .number()
        .int()
        .min(0)
        .max(MH_LIMITS.skin - 1),
    eyes: z
        .number()
        .int()
        .min(0)
        .max(MH_LIMITS.eyes - 1),
    brows: ItemId,
    hair: ItemId.nullable(),
    hairColor: Hex,
    beard: ItemId.nullable(),
    outfit: z
        .object({
        top: ItemId,
        bottom: ItemId,
        shoes: ItemId.nullable(),
        colors: z.object({ top: Hex, bottom: Hex, shoes: Hex }).strict(),
    })
        .strict(),
    accessories: z.array(ItemId).max(MH_LIMITS.accessories),
})
    .strict();
//# sourceMappingURL=mh-avatar.js.map